// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getCartOrderDetails } from '../../CartItemTile/container/CartItemTile.selectors';
import ConfirmationSelectors from '../../Confirmation/container/Confirmation.selectors';
import { isGuest } from '../../Checkout/container/Checkout.selector';
import { isPlccUser } from '../../../account/User/container/User.selectors';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import LoyaltyBannerLabels, { LOYALTY_LABELS } from './LoyaltyBanner.labels';

const getThresholdValue = (state) => {
  return state.session && state.session.siteDetails.PLCC_MARKETING_BAG_TOTAL_CUT_OFF;
};

const cartOrderDetails = createSelector(getCartOrderDetails, (cartOrderDetailsObj) => {
  const estimatedRewards = cartOrderDetailsObj.get('estimatedRewards');
  const subTotal = cartOrderDetailsObj.get('subTotal');
  const subTotalWithDiscounts = cartOrderDetailsObj.get('subTotalWithDiscounts');
  const cartTotalAfterPLCCDiscount = cartOrderDetailsObj.get('cartTotalAfterPLCCDiscount');
  const earnedReward = cartOrderDetailsObj.get('earnedReward');
  const pointsToNextReward = cartOrderDetailsObj.get('pointsToNextReward');
  return {
    estimatedRewards,
    subTotal,
    subTotalWithDiscounts,
    cartTotalAfterPLCCDiscount,
    earnedReward,
    pointsToNextReward,
  };
});

const confirmationDetails = createSelector(
  ConfirmationSelectors.getConfirmationSummary,
  (summary) => {
    const {
      estimatedRewards,
      subTotal,
      subTotalWithDiscounts,
      cartTotalAfterPLCCDiscount,
      earnedReward,
      pointsToNextReward,
    } = summary || {};
    return {
      estimatedRewards,
      subTotal,
      subTotalWithDiscounts,
      cartTotalAfterPLCCDiscount,
      earnedReward,
      pointsToNextReward,
    };
  }
);

const getFooterLabels = createSelector(
  [
    (state, pageCategory) => {
      return pageCategory;
    },
    isGuest,
    isPlccUser,
  ],
  (pageCategory, isGuestUser, isPlcc) => {
    let userType = '';
    if (isGuestUser) {
      userType = 'guest';
    } else if (!isPlcc) {
      userType = 'mpr';
    } else {
      userType = 'plcc';
    }
    const MAPPINGPAGETYPE = {
      isAddedToBagPage: 'added2bag',
      bagPage: 'bag',
      review: 'review',
      confirmation: 'confirmation',
      isProductDetailView: 'pdp',
    };
    const currentPage = MAPPINGPAGETYPE[pageCategory] || 'bag';
    const labelKeys = [
      // `lbl_banner_${currentPage}_${userType}_link1_text`,
      `lbl_banner_${currentPage}_${userType}_link1_action`,
      `lbl_banner_${currentPage}_${userType}_link1_prefix`,
      `lbl_banner_${currentPage}_${userType}_link2_text`,
      `lbl_banner_${currentPage}_${userType}_link2_action`,
      `lbl_banner_${currentPage}_${userType}_link2_prefix`,
      'lbl_banner_bag_link_prefix',
    ];
    const labelsList = [
      // 'link1Text',
      'link1Action',
      'link1Prefix',
      'link2Text',
      'link2Action',
      'link2Prefix',
      'linkPrefix',
    ];
    const finalValue = {};
    labelKeys.forEach((key, index) => {
      const revievedKey = getLabelFromCopyOrFromTranslation(
        `${LOYALTY_LABELS}.${key}`,
        LoyaltyBannerLabels
      );
      finalValue[labelsList[index]] = revievedKey === key ? '' : revievedKey;
    });

    return finalValue;
  }
);

export { getThresholdValue, cartOrderDetails, confirmationDetails, getFooterLabels };
